import React, {ReactElement} from 'react';
import {Props} from './Props';
import {State, TravelTimeTab} from './State';
import TabBar from '../../../../../../components/TabBar';
import {TabBarItem} from '../../../../../../components/TabBar/Props';
import StyledButton from '../../../../../../components/StyledButton';
import DateTimeFormatted from '../../../../../../components/DateTimeFormatted';
import {css} from 'aphrodite/no-important';
import styles from './styles';
import SimpleGraph from '../../../../../../components/SimpleGraph';

class DialogTravelTimeV2 extends React.Component<Props, State> {
    tabBarItems: TabBarItem<TravelTimeTab>[];
    chartColors: { actual: string; freeFlow: string };
    private static readonly ONE_HOUR_IN_SECONDS = 3600;
    private static readonly ONE_DAY_IN_SECONDS = 86400;

    constructor(props: Props) {
        super(props);

        this.state = {
            currentTab: TravelTimeTab.travelTime,
            tabTimestamp: 3600,
        };

        this.tabBarItems = [
            {
                id: TravelTimeTab.travelTime,
                name: 'Reistijd',
            },
            {
                id: TravelTimeTab.velocity,
                name: 'Snelheid',
            },
        ];

        this.chartColors = {
            actual: '#ac183d',
            freeFlow: '#3cb44b',
        };
    }

    componentDidMount(): void {
        this.triggerOpenDialog();
    }

    componentWillUnmount(): void {
        const {properties, mapSourceID, closeDialog} = this.props;
        closeDialog(mapSourceID, properties.id);
    }

    changeCurrentActiveTab = (currentTab: TravelTimeTab): void => this.setState({currentTab});

    changeTimestamp = (): void => {
        this.setState(
            {
                tabTimestamp: this.state.tabTimestamp === DialogTravelTimeV2.ONE_DAY_IN_SECONDS ? DialogTravelTimeV2.ONE_DAY_IN_SECONDS : DialogTravelTimeV2.ONE_HOUR_IN_SECONDS,
            },
            () => this.triggerOpenDialog(),
        );
    };

    triggerOpenDialog = (): void => {
        const {properties, mapSourceID, openGraphDialog, featureId} = this.props;
        const {tabTimestamp} = this.state;

        openGraphDialog(mapSourceID, featureId, properties.externalId, 'travel-time-v2', tabTimestamp);
    };

    render(): ReactElement {
        const {featureState, graphData, showRecordIds} = this.props;
        const {currentTab, tabTimestamp} = this.state;

        return (
            <>
                <table>
                    <tbody>
                        {showRecordIds && (
                            <tr>
                                <th>ID</th>
                                <td>{this.getTrajectoryID()}</td>
                            </tr>
                        )}
                        <tr>
                            <th>Naam</th>
                            <td>{featureState.name}</td>
                        </tr>
                        <tr>
                            <th>Lengte in meters</th>
                            <td>{featureState.lengthInMeters}</td>
                        </tr>
                        <tr>
                            <th>Tijdstempel</th>
                            <td>
                                <DateTimeFormatted dateTime={featureState.updatedAt}/>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <StyledButton
                    onPress={() => this.openInDexterAvg()}
                    title={'Historische reistijden en  snelheden bekijken in Dexter'}
                />

                <StyledButton
                    onPress={() => this.openInDexterFcd()}
                    title={'Historische reistijden en snelheden bekijken in FCD explorer'}
                />

                <br/>

                <TabBar<TravelTimeTab>
                    tabBarItems={this.tabBarItems}
                    activeId={currentTab}
                    onClickedOnTab={(id) => this.changeCurrentActiveTab(id)}
                />

                <div className={css(styles.tabContent)}>
                    <div
                        style={{
                            display: currentTab === TravelTimeTab.travelTime ? 'block' : 'none',
                        }}
                    >
                        <table className={'last-column-right'}>
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Seconden</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Actueel</td>
                                    <td
                                        className={css(styles.tableTravelTimeVelocityRightBorder)}
                                        style={{
                                            borderRightColor: this.chartColors.actual,
                                        }}
                                    >
                                        {featureState.travelTime}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Free flow</td>
                                    <td
                                        className={css(styles.tableTravelTimeVelocityRightBorder)}
                                        style={{
                                            borderRightColor: this.chartColors.freeFlow,
                                        }}
                                    >
                                        {featureState.freeflowTravelTime}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <SimpleGraph
                            data={graphData?.travelTime || []}
                            title={'Voertuigen overzicht'}
                            width={357}
                            revision={graphData?.timeStamp || 0}
                        />

                        <br/>
                        <p>Weergeef data in de grafiek van de afgelopen:</p>
                        <StyledButton
                            onPress={this.changeTimestamp}
                            title={tabTimestamp === 3600 ? '1-uur' : '24-uur'}
                        />
                    </div>

                    <div
                        style={{
                            display: currentTab === TravelTimeTab.velocity ? 'block' : 'none',
                        }}
                    >
                        <table className={'last-column-right'}>
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>KM/h</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Actueel</td>
                                    <td
                                        className={css(styles.tableTravelTimeVelocityRightBorder)}
                                        style={{
                                            borderRightColor: this.chartColors.actual,
                                        }}
                                    >
                                        {featureState.speed}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Free flow</td>
                                    <td
                                        className={css(styles.tableTravelTimeVelocityRightBorder)}
                                        style={{
                                            borderRightColor: this.chartColors.freeFlow,
                                        }}
                                    >
                                        {featureState.freeflowSpeed}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <SimpleGraph
                            data={graphData?.speed || []}
                            title={'Voertuigen overzicht'}
                            width={357}
                            revision={graphData?.timeStamp || 0}
                        />

                        <br/>
                        <p>Weergeef data in de grafiek van de afgelopen:</p>
                        <StyledButton
                            onPress={this.changeTimestamp}
                            title={tabTimestamp === 3600 ? '1-uur' : '24-uur'}
                        />
                    </div>
                </div>
            </>
        );
    }

    private getTrajectoryID(): string {
        const {properties} = this.props;

        try {
            const parsed = JSON.parse(properties.locations);
            return parsed[0];
        } catch (e) {
            return properties.externalId.toString();
        }
    }

    private openInDexterAvg(): void {
        window
            .open(`https://dexter.ndw.nu/deeplink/explorer/avg?id=${this.getTrajectoryID()}&type=trajectory`, '_blank')
            ?.focus();
    }

    private openInDexterFcd(): void {
        window.open(`https://dexter.ndw.nu/deeplink/explorer/fcd?id=${this.getTrajectoryID()}`, '_blank')?.focus();
    }
}

export default DialogTravelTimeV2;
